import axios from 'axios';
import config from '../config/config';
import { getAuthToken } from '../utils/token';

const BASE_URL = `${config.API}/rejectionlevel`;

const getAuthConfig = () => {
    const token = getAuthToken();

    return {
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    };
};

export const getRejectionLevels = async (params = {}) => {
    const response = await axios.get(
        `${BASE_URL}/index`,
        {
            ...getAuthConfig(),
            params,
        }
    );

    return response.data;
};

export const getRejectionLevelById = async (id) => {
    const response = await axios.get(
        `${BASE_URL}/${id}`,
        getAuthConfig()
    );

    return response.data;
};

export const createRejectionLevel = async (data) => {
    const response = await axios.post(
        `${BASE_URL}/create`,
        data,
        getAuthConfig()
    );

    return response.data;
};

export const updateRejectionLevel = async (id, data) => {
    const response = await axios.put(
        `${BASE_URL}/update/${id}`,
        data,
        getAuthConfig()
    );

    return response.data;
};

export const deleteRejectionLevel = async (id) => {
    const response = await axios.delete(
        `${BASE_URL}/delete/${id}`,
        getAuthConfig()
    );

    return response.data;
};

export const restoreRejectionLevel = async (id) => {
    const response = await axios.patch(
        `${BASE_URL}/${id}/restore`,
        {},
        getAuthConfig()
    );

    return response.data;
};
